import { zodTransformFirestoreTimestampToDate } from "../utils/zodUtils.mjs";
import { zodFlavorId } from "./ids.mjs";
import { z as z$1 } from "zod";

// src/models/coachConsultation.ts
const coachConsultationStatusSchema = z$1.enum([
	"scheduled",
	"completed",
	"canceled",
	"untracked",
	"noshow"
]);
const coachConsultationSchema = z$1.object({
	id: zodFlavorId(),
	startTime: z$1.any().transform(zodTransformFirestoreTimestampToDate).optional(),
	coachId: z$1.string().optional(),
	bookedAt: z$1.any().transform(zodTransformFirestoreTimestampToDate).optional(),
	eventId: z$1.string().optional(),
	referralProgramId: zodFlavorId().optional(),
	completedAt: z$1.any().transform(zodTransformFirestoreTimestampToDate).optional(),
	consultationStatus: coachConsultationStatusSchema.optional()
});

export { coachConsultationSchema };
//# sourceMappingURL=coachConsultation.mjs.map